import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// Service
import AuthDeviceService from "../../services/Auth.Device.service";
import AuthOrganizationService from "services/Auth.Organization.service";

const initialState = {
  deviceOverview: null,
  deviceList: null,
  mspPages: 0,
  orgList: null,
  orgCount: 0,
  fetchedOrgCount: 0,
};

export const addDevice = createAsyncThunk(
  "deviceSetting/removeDevice",
  async (data, thunkAPI) => {
    try {
      const response = await AuthDeviceService.addDevice(data);

      if (response.error) {
        return thunkAPI.rejectWithValue(response.error);
      }

      return response.data;
    } catch (err) {}
  }
);

export const removeDevice = createAsyncThunk(
  "deviceSetting/removeDevice",
  async (data, thunkAPI) => {
    try {
      const response = await AuthDeviceService.removeDevice(data);

      if (response.error) {
        return thunkAPI.rejectWithValue(response.error);
      }

      return response.data;
    } catch (err) {}
  }
);

export const bulkAssign = createAsyncThunk(
  "deviceSetting/bulkAssign",
  async ([data, orgId], thunkAPI) => {
    try {
      const response = await AuthOrganizationService.bulkAssign(data, orgId);

      if (response.error) {
        return thunkAPI.rejectWithValue(response.error);
      }

      return response.data;
    } catch (err) {}
  }
);

export const bulkAssignToExistedSite = createAsyncThunk(
  "deviceSetting/bulkAssign",
  async ([data, orgId], thunkAPI) => {
    try {
      const response = await AuthOrganizationService.bulkAssignToExistedSite(
        data,
        orgId
      );

      if (response.error) {
        return thunkAPI.rejectWithValue(response.error);
      }

      return response.data;
    } catch (err) {}
  }
);

export const bulkAssignToNewOrg = createAsyncThunk(
  "deviceSetting/bulkAssign",
  async ([data, orgId], thunkAPI) => {
    try {
      const response = await AuthOrganizationService.bulkAssignToNewOrg(
        data,
        orgId
      );

      if (response.error) {
        return thunkAPI.rejectWithValue(response.error);
      }

      return response.data;
    } catch (err) {}
  }
);

export const bulkAssignToNewSite = createAsyncThunk(
  "deviceSetting/bulkAssign",
  async ([data, orgId], thunkAPI) => {
    try {
      const response = await AuthOrganizationService.bulkAssignToNewSite(
        data,
        orgId
      );

      if (response.error) {
        return thunkAPI.rejectWithValue(response.error);
      }

      return response.data;
    } catch (err) {}
  }
);

export const unregisterDevice = createAsyncThunk(
  "deviceSetting/removeDevice",
  async (data, thunkAPI) => {
    try {
      const response = await AuthDeviceService.unregisterDevice(data);

      if (response.error) {
        return thunkAPI.rejectWithValue(response.error);
      }

      return response.data;
    } catch (err) {}
  }
);

export const fetchDeviceOverview = createAsyncThunk(
  "deviceSetting/fetchDeviceOverview",
  async (orgId, thunkAPI) => {
    const response = await AuthOrganizationService.getDeviceOverview(orgId);
    if (response.error) {
      return thunkAPI.rejectWithValue(response.error.code);
    }
    return response.data;
  }
);

export const searchOrg = createAsyncThunk(
  "deviceSetting/searchOrg",
  async ([orgId, orgName, skip, limit], thunkAPI) => {
    const response = await AuthOrganizationService.searchOrg(
      orgId,
      orgName,
      skip,
      limit
    );
    if (response.error) {
      return thunkAPI.rejectWithValue(response.error.code);
    }
    return response;
  }
);

export const fetchDevicelist = createAsyncThunk(
  "deviceSetting/fetchDevicelist",
  async (
    [
      orgId,
      deviceTotalCount,
      skip = 0,
      sort = "",
      reverse = 1,
      isOrgLevel = true,
      filter = {},
    ],
    thunkAPI
  ) => {
    const response = await AuthOrganizationService.getDevicelist(
      orgId,
      deviceTotalCount,
      skip,
      sort,
      reverse,
      isOrgLevel,
      filter
    );
    if (response.error) {
      return thunkAPI.rejectWithValue(response.error.code);
    }
    return response;
  }
);

const deviceSettingSlice = createSlice({
  name: "deviceSetting",
  initialState,
  reducers: {
    cleanOrg(state) {
      state.orgList = null;
      state.orgCount = 0;
      state.fetchedOrgCount = 0;
    },
    cleanDeviceOverview(state) {
      state.deviceOverview = null;
    },
  },
  extraReducers: {
    [fetchDeviceOverview.fulfilled.type]: (state, action) => {
      state.deviceOverview = action.payload;
    },
    [fetchDevicelist.fulfilled.type]: (state, action) => {
      state.deviceList = action.payload.data;
      if (action.payload.paging.hasOwnProperty("total"))
        state.mspPages = action.payload.paging.total;
    },
    [searchOrg.fulfilled.type]: (state, action) => {
      console.dir(action.payload);
      if (state.orgList === null) state.orgList = action.payload.data;
      else state.orgList = [...state.orgList, ...action.payload.data];
      state.fetchedOrgCount =
        state.fetchedOrgCount + action.payload.data.length;
      if (action.payload.hasOwnProperty("total"))
        state.orgCount = action.payload.total;
    },
  },
});

export const deviceSettingActions = deviceSettingSlice.actions;

export default deviceSettingSlice;
